// 页面级翻译总开关: 英文时加载页面字典 (单独分包, 中文用户不下载),
// 启动 DOM 翻译层、图表翻译和原生对话框翻译; 切回中文时全部还原。
import { EN } from './en';
import { setChartLanguage } from './chartTranslator';
import { DomTranslator } from './domTranslator';
import { createTextTranslator, translatePreservingSpace, type TextTranslator } from './textTranslator';
import type { Lang } from '.';

let dom: DomTranslator | null = null;
let generation = 0;
let nativeConfirm: typeof window.confirm | null = null;
let nativeAlert: typeof window.alert | null = null;
let cachedTranslator: TextTranslator | null = null;

async function loadTranslator() {
  if (cachedTranslator) return cachedTranslator;
  const { EN_PAGES } = await import('./en.pages');
  // 手工维护的 EN (外壳、爱压、新页面) 优先于批量生成的页面字典
  cachedTranslator = createTextTranslator({ ...EN_PAGES, ...EN });
  return cachedTranslator;
}

export async function applyPageLanguage(lang: Lang) {
  const current = ++generation;
  if (lang === 'en') {
    const translator = await loadTranslator();
    if (current !== generation) return;   // 加载期间又切回了中文
    dom?.stop();
    dom = new DomTranslator(translator);
    dom.start();
    if (!nativeConfirm) {
      nativeConfirm = window.confirm.bind(window);
      nativeAlert = window.alert.bind(window);
      window.confirm = (msg?: string) => nativeConfirm!(msg ? translatePreservingSpace(translator, msg) ?? msg : msg);
      window.alert = (msg?: unknown) => nativeAlert!(typeof msg === 'string' ? translatePreservingSpace(translator, msg) ?? msg : msg);
    }
    await setChartLanguage(translator).catch(() => undefined);
  } else {
    dom?.stop();
    dom = null;
    if (nativeConfirm) { window.confirm = nativeConfirm; nativeConfirm = null; }
    if (nativeAlert) { window.alert = nativeAlert; nativeAlert = null; }
    await setChartLanguage(null).catch(() => undefined);
  }
}
